import React from 'react';
import PropTypes from 'prop-types';

import {
  AuthorsInput,
} from '../../../fragments/forms';


export default class AuthorInput extends React.Component {

  static propTypes = {
    reference: PropTypes.object.isRequired,
    readOnly: PropTypes.bool.isRequired,
    showError: PropTypes.bool.isRequired,
    onUpdate: PropTypes.func.isRequired,
  };

  handleUpdate(authors) {
    const {reference} = this.props;
    reference.authors = authors;
    reference.author = [authors];

    const {onUpdate} = this.props;
    onUpdate(reference);
  }

  get helpMessage() {
    return {
      level: 'info',
      text: <div>
        <p>
          Please click "+" to add new author.
        </p>
        <p>
          Author list, primary author first. Following are supported paste formats:
        </p>
        <ul>
          <li>
            Lexical name order 1:<br />
            <em>Bartolo I, Borrego P, Abecasis AB</em>
          </li>
          <li>
            lexical name order 2:<br />
            <em>Bartolo, I; Borrego, P; Abecasis, AB</em>
          </li>
          <li>
            Normal name order (prefixed with a "&lt;"):<br />
            <em><strong>&lt;</strong>Ines Bartolo, Pedro Borrego, and Ana B. Abecasis</em>
          </li>
        </ul>
      </div>
    };
  }

  get allMessage() {
    const {helpMessage} = this;
    const {reference, showError} = this.props;

    return [helpMessage].concat(
      reference.messages('author', showError)
    );
  }

  render() {
    const {reference, readOnly} = this.props;
    const {allMessage} = this;

    return (
      <AuthorsInput
       name="authors"
       value={reference.authors || []}
       readOnly={readOnly}
       onChange={this.handleUpdate.bind(this)}
       messages={allMessage}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/wizard/reference/reference-edit/author-input.js